import React, { useState } from "react";
import { FaTrash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { closeModal,refreshList } from "../redux/features/modalSlice";
import { successToast, errorToast } from "../Utils/toast";

function DeleteModal({
  title,
  message,
  deleteFunction,
  id,
  type ,
  onSuccess
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

 const handleDelete = async () => {
  try {
    setLoading(true);

   const res= await deleteFunction({
      id: id,
      type:type
    });

//  if (res?.success) {
//         successToast(res?.message );

//         // 👇 table refresh trigger
//         if (onSuccess) {
//           onSuccess();
//         }

//         dispatch(closeModal());
//       } else {
//         errorToast(res?.message );
//       }
if (res?.success) {
  successToast(res?.message );

  if (onSuccess) {
    onSuccess();
  }
 dispatch(refreshList());
  dispatch(closeModal());
} else {
  errorToast(res?.message || "Delete failed");
}
  } catch (error) {
    console.log(error);
    errorToast("Delete Failed ❌");
  } finally {
    setLoading(false);
  }
};

  return (
    <>
      <div className="custom-modal-body text-center">

        <div className="model-custum">
          <div className="delete-icon">
            <FaTrash />
          </div>

          <h3>{title}</h3>
          <p className="delete-text">{message}</p>
        </div>

      </div>

      <div className="modal-btn-group justify-content-center">

        <button
          className="cancel-btn"
          onClick={() => dispatch(closeModal())}
        >
          Cancel
        </button>

        <button
          className="delete-btn"
          onClick={handleDelete}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Yes Delete"}
        </button>

      </div>
    </>
  );
}

export default DeleteModal;